module.exports = __webpack_public_path__ + "img/salty-2.86c6d246.webp";